// Trader words for engine codes (UI/UX audit Phase 3). The raw code is never lost: callers put it in a
// tooltip (`title`) so support and audits still see exactly what the engine stored.

const EXIT = {
  PROFIT_TARGET: "Profit target hit",
  STOP_LOSS: "Stop loss hit",
  MANUAL: "Closed by you",
  MANUAL_CLOSE: "Closed by you",
  MANUAL_SQUARE_OFF: "Squared off by you",
  FORCE_SQUARE_OFF: "Force square-off",
  EMERGENCY_EXIT: "Emergency exit",
  TIME_EXIT: "Expiry-day time exit",
  SPOT_BREACH: "Underlying near a short strike",
  UNWIND_COMPLETE: "Unwound (entry did not complete)",
  ENTRY_ABORT_UNWIND: "Entry aborted — filled legs unwound",
  INVARIANT_BREACH: "Safety stop — legs out of balance",
  CANCELLED_BEFORE_ENTRY: "Cancelled before entry",
  OPPORTUNITY_GONE: "Opportunity gone before entry",
  EXIT_ALL: "Exit All & Stop",
  KILL_SWITCH: "Kill switch",
  EXPIRY: "Expired",
  FLAT: "Closed (flat)",
  AUTO_TARGET_REACHED: "Auto target reached",
  RESET_SQUARE_OFF: "Reset square-off",
  PAIR_AUTO_EXIT: "Pair auto-exit",
  PAIR_MANUAL_CLOSE: "Pair closed by you",
};

const REFUSAL = {
  BROKER_QUANTITY_ABOVE_OPTIONS_LIMIT: (m) => {
    const x = /\((\d+)>(\d+)=(\d+)x(\d+)\)/.exec(m);
    return x ? `order quantity ${x[1]} is above your per-order limit of ${x[3]} lot(s) (${x[2]})`
      : "order quantity is above your per-order options limit";
  },
  TICK_TOO_OLD: () => "the price was too old to trade on",
  OUTSIDE_TRADING_HOURS: () => "the market was closed",
  EXCHANGE_HOLIDAY: () => "the exchange is on holiday",
  MAX_LOSS_ABOVE_LIMIT: () => "its maximum loss is above your limit",
  STOP_LOSS_ABOVE_LIMIT: () => "its stop loss is above your limit",
  BROKER_WRITES_DISABLED: () => "order sending is switched off on the server",
};

const words = (code) => String(code || "").replace(/_/g, " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase());

/** "Profit target hit" for PROFIT_TARGET; an unknown code becomes readable words; empty -> "—". */
export function exitText(code) {
  if (!code) return "—";
  const c = String(code).trim();
  return EXIT[c.toUpperCase()] || refusalText(c) || words(c);
}

/** "Leg L4 refused: order quantity 90 is above your per-order limit of 1 lot(s) (30)" for
 *  LEG_REFUSED(L4:BROKER_QUANTITY_ABOVE_OPTIONS_LIMIT(90>30=1x30)); null when the code is not a refusal. */
export function refusalText(code) {
  const s = String(code || "");
  const leg = /^LEG_REFUSED\((L\d):(.*)\)$/.exec(s);
  const body = leg ? leg[2] : s;
  const key = Object.keys(REFUSAL).find((k) => body.startsWith(k));
  if (!key && !leg) return null;
  const reason = key ? REFUSAL[key](body) : words(body.replace(/\(.*$/, ""));
  return leg ? `Leg ${leg[1]} refused: ${reason}` : reason.charAt(0).toUpperCase() + reason.slice(1);
}

// Opportunity economics in trader words. The workbook column stays in the tooltip (J = expected P&L,
// N = J / margin M, O = N / days K) so the Excel parity is still traceable.
export const ECON_TITLE = {
  "Exp. P&L": "Expected P&L of the spread in rupees, before brokerage and slippage (workbook column J)",
  "Return on margin": "Expected P&L ÷ margin required (workbook column N, J / M). Ranking is by this, highest first",
  "Per day": "Return on margin ÷ days to the near leg's expiry (workbook column O, N / K)",
};
